module.exports = __webpack_public_path__ + "img/55.1115c707.png";